export * from './attributesDetailComponent';